import React from "react";
import Layout from "@/components/Layout";
import HomeSearchOverlay from "@/components/Pages/Home/HomeSearchOverlay";
import { getCommonStaticProps } from '@/utils/method'

const SearchPage = () => {
  const handleClose = () => {
    // 关闭时返回上一页或首页
    if (typeof window !== 'undefined') {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    }
  };

  return (
    <Layout isShowNav={true} isShowFoot={false} useBottomBar={false}>
      <HomeSearchOverlay visible={true} onClose={handleClose} />
    </Layout>
  );
};

export default SearchPage;

export async function getStaticProps(context) {
  return getCommonStaticProps(context);
}
